import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { BsFilter } from '@react-icons/all-files/bs/BsFilter';
import { BsFilterLeft } from '@react-icons/all-files/bs/BsFilterLeft';
import { TextInputField, SelectField, ButtonGroupField } from '@bucketplace/commerce-admin-ui';
import { LIGHT_THEME } from '@bucketplace/design-system';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import { DurationInputField } from '../../components/Duration/DurationInputField.js';
import '../../components/FormGroup/FormGroup.js';
import '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import { convertDurationFormat } from '../../utils/duration.js';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../components/FormContent.js';
import { InspectorFormProvider } from '../../components/InspectorFormProvider.js';
import { FieldItem } from '../../components/FieldItem.js';
import { ImageField } from '../../components/Input/ImageField/ImageField.js';
import { TIMER_PREFIX_MAP } from './Countdown.js';

var TIMER_PREFIX_OPTIONS = [{
  text: TIMER_PREFIX_MAP.start,
  value: 'start'
}, {
  text: TIMER_PREFIX_MAP.end,
  value: 'end'
}];
var TEXT_COLOR_OPTIONS = [{
  text: '블랙',
  value: LIGHT_THEME.base.neutral600
}, {
  text: '화이트',
  value: LIGHT_THEME.base.neutral0
}];
var ALIGN_OPTIONS = [{
  text: jsx(BsFilterLeft, null),
  value: 'left'
}, {
  text: jsx(BsFilter, null),
  value: 'center'
}];
function CountdownInspector(_ref) {
  var inspectorValue = _ref.value,
    onChange = _ref.onChange;
  var convertedDuration = convertDurationFormat(inspectorValue.props.duration);
  var formValue = _objectSpread2(_objectSpread2({}, inspectorValue), {}, {
    props: _objectSpread2(_objectSpread2({}, inspectorValue.props), {}, {
      duration: convertedDuration
    })
  });
  return jsx(InspectorFormProvider, {
    value: formValue,
    onChange: onChange
  }, jsx(FormContent, {
    header: "\uB178\uCD9C\uC2DC\uAC04 \uC124\uC815",
    required: true,
    direction: "VERTICAL"
  }, jsx(DurationInputField, {
    name: "duration"
  })), jsx(FormContent, {
    header: "\uCE74\uC6B4\uD2B8\uB2E4\uC6B4 \uC124\uBA85\uBB38\uAD6C",
    direction: "VERTICAL"
  }, jsx(FieldItem, {
    error: true,
    hint: "\uCD5C\uB300 20\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
    hintAlign: "end"
  }, jsx(TextInputField, {
    name: "subText",
    width: "100%",
    maxCount: 20
  }))), jsx(FormContent, {
    header: "\uD0C0\uC774\uBA38 \uC55E \uBB38\uAD6C",
    required: true
  }, jsx(SelectField, {
    name: "timerPrefix",
    width: "100%",
    options: TIMER_PREFIX_OPTIONS
  })), jsx(FormContent, {
    header: "\uC815\uB82C",
    required: true
  }, jsx(ButtonGroupField, {
    name: "align",
    width: "100%",
    options: ALIGN_OPTIONS
  })), jsx(FormContent, {
    header: "\uAE00\uC790\uC0C9",
    required: true
  }, jsx(SelectField, {
    name: "color",
    width: "100%",
    options: TEXT_COLOR_OPTIONS
  })), jsx(FormContent, {
    header: "\uBC30\uACBD\uC774\uBBF8\uC9C0"
  }, jsx(ImageField, {
    name: "backgroundImage"
  })));
}

export { CountdownInspector };
//# sourceMappingURL=Countdown.Inspector.js.map
